import React, { useState } from 'react';
import CompetencyHeader from './competencyHeader';
import CompetencyQuotes from './competencyQuotes';
import CompetencySynergies from './competencySynergies';
import CompetencyModal from './competencyModal';
import CompetencyHacks from './competencyHacks';
import classNames from 'classnames/bind';
import styles from './competencyType.module.scss';

const cx = classNames.bind(styles);

const CompetencyType = () => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <div className={cx('competencyTypeArea')}>
      <div className={cx('contentArea')}>
        {/* [D] 역량유형 설명 영역 */}
        <CompetencyHeader />

        {/* [D] 명언 영역 */}
        <CompetencyQuotes />
      </div>

      <div className={cx('contentArea')}>
        {/* [D] 꿀팁 영역 */}
        <CompetencyHacks />

        {/* [D] 시너지 영역 */}
        <CompetencySynergies setModalVisible={setModalVisible} />
      </div>

      {/* [D] 역량 유형 모달 */}
      <CompetencyModal visible={modalVisible} onClose={() => setModalVisible(false)} />
    </div>
  );
};

export default CompetencyType;
